import { Header1, SolidButton, formButton, styled } from "@iventis/styles";
import { Theme } from "@emotion/react";
import { ErrorImage } from "./error-image";

// Common styled components for error boundaries

export const StyledHeader1 = styled(Header1)`
    color: ${({ theme }: { theme: Theme }) => theme.primaryColors.focus};
    font-weight: 600;
`;

export const StyledErrorImage = styled(ErrorImage)`
    width: 80%;
    max-width: 333px;
`;

export const ErrorContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    text-align: center;
    gap: 20px;
    padding: 40px;
`;

export const ButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 20px;
`;

export const StyledButton = styled(SolidButton)`
    height: ${formButton.height};
    width: ${formButton.width};
`;

export const StyledLink = styled.a`
    color: ${({ theme }: { theme: Theme }) => theme.primaryColors.focus};
    font-weight: 600;
    text-decoration-line: underline;
`;

// Error overlay - gray background
export const ErrorOverlay = styled.div`
    background-color: gray;
    width: 100%;
    height: 100%;
`;
